import React, { useContext, useEffect, useState,Dispatch,SetStateAction, useRef, startTransition, useMemo } from "react";
import "./MainCorp.css"

import { ContainerRestau } from "../../../../components/containerRestau/containerRestau";
import { AppContext } from "../../../../context/AppContext";

import DefilmentBar from "../../../../components/defilmentBar/defilmentBar";
import { isBetween,formatDateToYMD, Restaurant, TypeResto, baseDays,Location,listCuisine, extractLastWord, cityWithOtherPreposition } from "../../../../components/types/types";
import { Link } from "react-router-dom";


interface MainCorpProps {
    listBase:Restaurant[],
    setCurrentLoc: Dispatch<SetStateAction<Location[]>>,
    setLengthResto: Dispatch<SetStateAction<number>>,
    cityLoad?:string,
    cityLoadBrut?:string
}
const toMinutes = (h: string): number => {
  const m = h.trim().match(/^(\d{1,2})h(\d{2})$/);
  if (!m) return NaN;
  const hh = parseInt(m[1], 10);
  const mm = parseInt(m[2], 10);
  return hh * 60 + mm;
};
const nowMinutes = (): number => {
  const d = new Date();
  return d.getHours() * 60 + d.getMinutes();
};
const getRangesForDate = (restaurant: Restaurant, date: Date): Array<[number, number]> => {
  const ymd = formatDateToYMD(date);
  const dayKey = baseDays[date.getDay()];
  const special = restaurant.special_date?.[ymd];
  if (special) {
    const isOpen = special[0];
    if (!isOpen) return [];

    const val = special[1];
    if (!Array.isArray(val)) return [];
    const rangesRaw: any[] = Array.isArray(val[0]) && Array.isArray(val[0][0]) ? val : [val];

    const ranges = rangesRaw
      .map((r) => [toMinutes(r[0]), toMinutes(r[1])] as [number, number])
      .filter(([s, e]) => Number.isFinite(s) && Number.isFinite(e));

    return ranges;
  }
  const sched = restaurant.schedule?.[dayKey];
  if (!Array.isArray(sched)) return [];
  const ranges = sched.map((r) => [toMinutes(r[0]), toMinutes(r[1])] as [number, number]).filter(([s, e]) => Number.isFinite(s) && Number.isFinite(e));
  return ranges;
};

const isStillValidForServiceFilter = (restaurant: Restaurant,service: "midi" | "soir"): boolean => {
  const today = new Date();
  const ranges = getRangesForDate(restaurant, today);
  if (!ranges.length) return false;
  const target = service === "midi" ? toMinutes("12h30") : toMinutes("20h00");
  const chosen =
    ranges.find(([s, e]) => s <= target && target <= e) ??
    (service === "midi" ? ranges[0] : ranges[ranges.length - 1]);

  const end = chosen[1];
  const now = nowMinutes();
  return now <= end;
};

const MainCorp:React.FC<MainCorpProps> = ({cityLoad='',cityLoadBrut='',listBase,setCurrentLoc,setLengthResto}) => {
    const {currentHomePage, setCurrentHomePage,setDate_selected,setFilterChoose,filterChoose,restoFav,searchValueHome,date_selected,hour_selected,isLogin, idRestaurant, setHour_selected} = useContext(AppContext)
    const [listRestoFilter,setListRestoFilter] = useState<Restaurant[]>([])
    const [listRestoBackup, setListRestoBackup] = useState<Restaurant[]>([]);
    const title = `QuelResto vous permet (enfin) de trouver facilement un bon restaurant en ligne.`

    const isDesktop = window.matchMedia("(min-width:701px)").matches;
    const LIMIT = isDesktop ? 12 : 3;
    const INITIAL_LIMIT = isDesktop ? 15 : 4;
    const [unlocked,setUnLocked]= useState(false)
    const containerRestoRef = useRef<HTMLDivElement>(null)
    const currentYear = new Date().getFullYear();
    useEffect(() => {
        
        if(containerRestoRef && containerRestoRef.current) {
            const observer = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting) {
                        setUnLocked(true)
                        observer.disconnect();
                    }
                },
                { threshold: 0.1 } 
            );

            if (containerRestoRef.current) {
                observer.observe(containerRestoRef.current);
            }

            return () => {
                observer.disconnect();
            }
        }
    }, [containerRestoRef.current]);

    const filterRestaurants = (restaurants: Restaurant[]): Restaurant[] => {
        if (filterChoose.length === 0) return restaurants;

        const filterCuisines = filterChoose.filter(filter => typeof filter === 'string' && listCuisine.includes(filter));
        
        const filterTypes = filterChoose.filter(filter => typeof filter === 'string' && TypeResto.includes(filter))
        const filterTypesSecond = filterTypes.map(type => extractLastWord(type as string));


        const filteredByCuisine = restaurants.filter(restaurant => 
            filterCuisines.some(cuisine => restaurant.cuisines.includes(cuisine as string))
        );

        const filteredByType = restaurants.filter(restaurant => 
            filterTypes.some(type => restaurant.type[0] === type ||  (restaurant.type.length > 1 && extractLastWord(restaurant.type[1]) === extractLastWord(type as string)))
        );

        const uniqueRestaurants = [...restaurants,...filteredByCuisine,...filteredByType].filter((restaurant, index, self) => 
            index === self.findIndex((r) => r.idrestaurant === restaurant.idrestaurant )
        );
    
        return uniqueRestaurants.filter(restaurant => {
                let countCuisine = 0;
                let countType = 0;
                if(filterCuisines.includes(restaurant.cuisines[0]) || filterCuisines.includes(restaurant.cuisines[1])) countCuisine += 1
                if(filterTypes.includes(restaurant.type[0]) ||  (restaurant.type.length > 1 && filterTypesSecond.includes(extractLastWord(restaurant.type[1])))) countType += 1
                return filterChoose.every(filter => {
                    if (typeof filter === 'string') {
                        if(listCuisine.includes(filter)) {          
                            if(countCuisine>0) return true                
                        }
                        if(TypeResto.includes(filter)) {          
                            if(countType>0) return true                
                        }
                        if(['Ouvert ce midi', 'Ouvert ce soir', 'A proximité'].includes(filter)) {
                            if('Ouvert ce midi' === filter) {
                                return isStillValidForServiceFilter(restaurant, "midi");
                            }
                            if ('Ouvert ce soir' === filter) {
                                return isStillValidForServiceFilter(restaurant, "soir");
                            }
                            return true
                        }
                        return (
                            (['5 étoiles', '4 étoiles', '3 étoiles'].includes(filter) &&
                                restaurant.note >= parseFloat(filter[0])) ||
                                 (restaurant.filters?.includes(filter))
                        );
                    }
                    else if (Array.isArray(filter) ) {
                        const nbr0 = filter[0]
                        const nbr1 = filter[1]
                        return (nbr0 <= restaurant.total_price && restaurant.total_price <= nbr1)
                    }
                    return true
                    
                })
        });
    };
 

    
    const changementSchedule_Date =() => {
        if(hour_selected !== '') {
            if(date_selected) {
                const formattedDate = formatDateToYMD(date_selected)
                const prevList = listBase.filter((elem) => {
                    if(elem.special_date) { 
                        if(elem.special_date[formattedDate]) { 
                            if(elem.special_date[formattedDate][0]) {
                                if(Array.isArray(elem.special_date[formattedDate][1])) {
                                    if(isBetween(elem.special_date[formattedDate][1][0][0],elem.special_date[formattedDate][1][0][1],hour_selected)) return elem
                                    else if(elem.special_date[formattedDate][1].length > 1 && isBetween(elem.special_date[formattedDate][1][1][0],elem.special_date[formattedDate][1][1][1],hour_selected)) return elem
                                }
                                else return 
                            }  
                            else return
                        }
                    }
                    
                    if(Array.isArray(elem.schedule[baseDays[date_selected.getDay()]])) {
                        if(isBetween(elem.schedule[baseDays[date_selected.getDay()]][0][0],elem.schedule[baseDays[date_selected.getDay()]][0][1],hour_selected)) return elem
                        else if(elem.schedule[baseDays[date_selected.getDay()]].length > 1 && isBetween(elem.schedule[baseDays[date_selected.getDay()]][1][0],elem.schedule[baseDays[date_selected.getDay()]][1][1],hour_selected)) return elem
                    }
                    else return 
                    
                })
                const filteredList = filterRestaurants(prevList);
                return filteredList;
            }
            else {
                const today = new Date()
                const formattedDate = formatDateToYMD(today)
                const prevList = listBase.filter((elem) => {
                    if(elem.special_date) { 
                        if(elem.special_date[formattedDate]) { 
                            if(elem.special_date[formattedDate][0]) return elem   
                            else return
                        }
                    }   
                    if(Array.isArray(elem.schedule[baseDays[today.getDay()]])) {
                        if(isBetween(elem.schedule[baseDays[today.getDay()]][0][0],elem.schedule[baseDays[today.getDay()]][0][1],hour_selected)) return elem
                        else if(elem.schedule[baseDays[today.getDay()]].length > 1 && isBetween(elem.schedule[baseDays[today.getDay()]][1][0],elem.schedule[baseDays[today.getDay()]][1][1],hour_selected)) return elem
                    }
                    else return 
                    
                })
                const filteredList = filterRestaurants(prevList);
                return filteredList;
            }
        }
        else if(date_selected) {
       
            const formattedDate = formatDateToYMD(date_selected)
            const prevList = listBase.filter((elem) => {
                if(elem.special_date) { 
                    if(elem.special_date[formattedDate]) { 
                        if(elem.special_date[formattedDate][0]) return elem   
                        else return
                    }
                }
                if(Array.isArray(elem.schedule[baseDays[date_selected.getDay()]])) return elem
                
            })
            const filteredList = filterRestaurants(prevList);
            return filteredList;
        }
        else {
            const filteredList = filterRestaurants(listBase);
            return filteredList;
        }
    } 

    useEffect(() => {
        if(filterChoose.includes('Ouvert ce midi')) {
            if(filterChoose.includes('Ouvert ce soir')) {
                setFilterChoose(filterChoose.filter((elem) => elem !== 'Ouvert ce soir'))
                return;
            }
            setDate_selected(new Date())
            setHour_selected('12h30')
        }
        else if(filterChoose.includes('Ouvert ce soir')) {
            if(filterChoose.includes('Ouvert ce midi')) {
                setFilterChoose(filterChoose.filter((elem) => elem !== 'Ouvert ce midi'))
                return
            }
            setDate_selected(new Date())
            setHour_selected('20h00') 
        }
        const filteredList = changementSchedule_Date();
        const newLocations = (filteredList.length > 0 ? filteredList : listBase).map((resto) => {
            const [lng, lat] = resto.location.coordinates;
            return {lat,lng, name: resto.name,idrestaurant: resto.idrestaurant,id_url:resto.id_url,devanture:resto.devanture,type:resto.type,note:resto.note,address_hint:resto.address_hint || '',
                address:resto.address,phone:resto.phone,listImg:resto.listimg ? resto.listimg : [],schedule:resto.schedule,date_update:resto.date_update,nbr_review:resto.nbr_review || 0,filters:resto.filters || [],
                special_date : resto.special_date ? resto.special_date : {}, biography : resto.biography, total_price:resto.total_price, cuisines: resto.cuisines,is_resa_phone:resto.is_resa_phone };
        });
        
        startTransition(() => {
            setCurrentLoc(newLocations)
            setListRestoBackup(filteredList);
            setListRestoFilter(filteredList);
            setCurrentHomePage(1);   
        })  
    }, [filterChoose]); 

    useEffect(() => {
        const filteredList = changementSchedule_Date()
        const newLocations = (filteredList.length > 0 ? filteredList: listBase).map((resto) => {
            const [lng, lat] = resto.location.coordinates;
            return {lat,lng, name: resto.name,id_url:resto.id_url,idrestaurant: resto.idrestaurant,devanture:resto.devanture,type:resto.type,note:resto.note,address:resto.address,phone:resto.phone,address_hint:resto.address_hint || '',
                listImg:resto.listimg ? resto.listimg : [],schedule:resto.schedule,special_date : resto.special_date ? resto.special_date : {},date_update:resto.date_update,nbr_review:resto.nbr_review || 0,filters:resto.filters || [],
                 biography: resto.biography, total_price:resto.total_price, cuisines: resto.cuisines,is_resa_phone:resto.is_resa_phone };
        });
        startTransition(() => {
            setCurrentLoc(newLocations)
            setListRestoBackup(filteredList);
            setListRestoFilter(filteredList);
            setCurrentHomePage(1); 
        })
        const viewResto = document.getElementById('mainCorpRestau');
        viewResto?.scrollTo(0, 0);
    },[listBase]) 

    useEffect(() => {
        const list = changementSchedule_Date()
        startTransition(() => {
            setListRestoBackup(list);
            setListRestoFilter(list);
        })
    },[hour_selected,date_selected])  

    useEffect(() => {
        if(listRestoFilter && listRestoFilter.length > 0){setCurrentHomePage(1); setLengthResto(listRestoFilter.length)}
        else if(listRestoBackup && listRestoBackup.length > 0) setLengthResto(listRestoBackup.length)
    },[listRestoFilter])


    const normalizeCity = (s?: string) =>
        (s || "").trim().toLowerCase();

    const sortedList = useMemo(() => {
        const base = listRestoFilter ?? [];
        if (!base.length) return [];

        const q = searchValueHome.trim().toLowerCase();
        const filtered = q ? base.filter(r => r.name.toLowerCase().includes(q)) : base;
        const targetCity = normalizeCity(cityLoadBrut);
        const doSplit = targetCity && targetCity !== normalizeCity("à proximité");

        const boostFirst = (arr: Restaurant[]) => {
            if (!idRestaurant || idRestaurant === -1) return arr;
            const copy = arr.slice();
            copy.sort((a, b) => {
            if (a.idrestaurant === idRestaurant) return -1;
            if (b.idrestaurant === idRestaurant) return 1;
            return 0;
            });
            return copy;
        };

        if (!doSplit) {
            return boostFirst(filtered);
        }

        const inCity: Restaurant[] = [];
        const around: Restaurant[] = [];

        for (const r of filtered) {
            const rCity = normalizeCity(r.address?.[1]);
            if (rCity === targetCity) inCity.push(r);
            else around.push(r);
        }
        return [...boostFirst(inCity), ...boostFirst(around)];
    }, [listRestoFilter, searchValueHome, idRestaurant, cityLoadBrut]);

    const { indexFirstAround, hasCityResto } = useMemo(() => {
        if (!cityLoadBrut || cityLoadBrut === 'à proximité') return { indexFirstAround: -1, hasCityResto: true };
        if (!sortedList.length) return { indexFirstAround: -1, hasCityResto: false };
        const hasCityResto = sortedList.some(
            (r) => r.address && r.address[1] === cityLoadBrut
        );
        if (!hasCityResto) {
            return { indexFirstAround: 0, hasCityResto: false };
        }
        const idx = sortedList.findIndex(
            (r) => !r.address || r.address[1] !== cityLoadBrut
        );
        return { indexFirstAround: idx, hasCityResto: true };
    }, [sortedList, cityLoadBrut]);

    const pageItems = useMemo(() => {
        const start = (currentHomePage - 1) * 30;
        return sortedList.slice(start, start + 30);
    }, [sortedList, currentHomePage]);

    useEffect(() => {
        window.scrollTo({top: 0,behavior: 'auto'})
    },[searchValueHome,hour_selected,date_selected,filterChoose])

    useEffect(() => {
        if (window.innerWidth > 700 || !pageItems?.length) return;
        
        let cleanup: (() => void) | null = null;
        const timer = setTimeout(() => {
            let scheduled = false;
            let containers: HTMLElement[] = [];

            const checkCentered = () => {
                scheduled = false;
                const viewportCenter = window.innerHeight / 2;
                let minDistance = Infinity;
                let centered: HTMLElement | null = null;
                for (const el of containers) {
                    const rect = el.getBoundingClientRect();
                    if (rect.bottom < 0 || rect.top > window.innerHeight) continue;
                    
                    const elemCenter = rect.top + rect.height / 2;
                    const dist = Math.abs(elemCenter - viewportCenter);
                    
                    if (dist < minDistance) {
                        minDistance = dist;
                        centered = el;
                    }
                }
                for (const el of containers) {
                    const shouldBeCentered = el === centered;
                    const isCentered = el.classList.contains('centered');
                    
                    if (shouldBeCentered && !isCentered) {
                        el.classList.add('centered');
                    } else if (!shouldBeCentered && isCentered) {
                        el.classList.remove('centered');
                    }
                }
            };
            const onScroll = () => {
                if (scheduled) return;
                scheduled = true;
                requestAnimationFrame(checkCentered);
            };
            containers = Array.from(document.querySelectorAll<HTMLElement>('.containerRestauUp'));
            if (!containers.length) return;

            window.addEventListener('scroll', onScroll, { passive: true });
            requestAnimationFrame(checkCentered);

            cleanup = () => {
                window.removeEventListener('scroll', onScroll);
            };
        }, 3000);

        return () => {
            clearTimeout(timer);
            if (cleanup) cleanup();
        };
    }, [pageItems]);

    return (
            <div className="mainCorpRestau" id='mainCorpRestau' >
                {cityLoad && cityLoad !== 'restaurants-a-proximite' && <div className="titleCityLoad"><h1 className=" largerTitle" >Les meilleurs restaurants {cityLoad}{cityLoad !== 'à proximité' ? `, Maine-et-Loire – ${currentYear}` : ''}</h1></div>}
                {listRestoFilter.length > 0 && <span className="numberList XsmallText ">{`${sortedList.length} résultat${sortedList.length>1? 's' : ''}`}</span> }
                {isLogin === 0 && <Link to="/contact_inscription" className="registerResto pointer lowOpacityHover XsmallText">Inscrire son restaurant</Link> }
                {!hasCityResto && listRestoFilter.length > 0 && cityLoad && <p className="title midText explainCity" >Aucun restaurant correspondant dans la ville recherchée</p>}
                { 
                    listRestoFilter.length > 0 ? 
                    pageItems.map((elem,index) => {
                        const globalIndex = (currentHomePage - 1) * 30 + index;
                        const showAroundTitle =
                            !!cityLoad &&
                            cityLoad !== 'restaurants-a-proximite' &&
                            indexFirstAround !== -1 &&
                            globalIndex === indexFirstAround;
                        return <React.Fragment key={'elemListContainer' + elem.idrestaurant}>
                            {showAroundTitle && (
                                <div className="aroundTitle">
                                    <div className={`${(!hasCityResto && listRestoFilter.length > 0 && cityLoad) ? 'isAtTop' : ''}`}></div>
                                    <h2 className="largerTitle">
                                        Recherche étendue : les meilleurs restaurants aux alentours {cityWithOtherPreposition(cityLoad)}
                                    </h2>
                                </div>
                            )}
                            <ContainerRestau  imgLocked={!unlocked ? index > INITIAL_LIMIT : false} id={index}  visibleCity={elem.visiblecity || ''} city={elem.address[1]} total_price={elem.total_price} cuisines={elem.cuisines} idResto={elem.idrestaurant}   img={elem.devanture} name={elem.name} note={elem.note} imgSup={elem.listimg} isFav={restoFav.includes(elem.idrestaurant)} type={elem.type} nbr_review={elem.nbr_review} date_published={elem.date_published} id_url={elem.id_url}/>   
                            {currentHomePage===1 && index === LIMIT &&  (
                            <div ref={containerRestoRef} style={{ height: 1 }} />
                            )}
                        </React.Fragment>
                        })
                        :
                        <div className="noFilterMatch">
                            {
                                listRestoBackup && listRestoBackup.length > 0 ?
                                <>
                                    <p className="titleList midText">Liste de restaurant se rapprochant le plus de votre recherche :</p>
                                    <div className="liste">
                                        {
                                        listRestoBackup.length > 0  && listRestoBackup.slice((currentHomePage-1)*30,currentHomePage*30).map((elem,index) => (
                                            <ContainerRestau id={index} key={'secondContainer'+elem.idrestaurant} visibleCity={elem.visiblecity || ''} city={elem.address[1]} total_price={elem.total_price} cuisines={elem.cuisines} idResto={elem.idrestaurant} img={elem.devanture} name={elem.name} note={elem.note} imgSup={elem.listimg} isFav={restoFav.includes(elem.idrestaurant)} type={elem.type}  nbr_review={elem.nbr_review} date_published={elem.date_published} id_url={elem.id_url}/>   
                                        ))
                                        }
                                    </div>
                                </>
                                :
                                <p className="title midText explainNoResto" >{cityLoad && filterChoose.length === 0 ? 'Aucun restaurant correspondant dans la ville recherchée' : `Aucun restaurant correspondant à votre recherche. Essayez d’enlever un ou plusieurs filtres pour voir plus de résultats.`}</p>
                            }
                        </div> 
                }
                {listRestoFilter.length > 0 && (
                    <div className="mainCorpTextAccueil">
                        <div className="textAccueil smallText">
                            {cityLoad ? <h2>{title}</h2> : <h1>{title}</h1>}<br/>
                            Ouvert depuis le 29 avril, notre objectif est de référencer tous les bons restaurants autour de vous.
                        </div>
                        <p className="textAccueil XsmallText" style={{marginTop:'3em'}}>
                           Pour en savoir plus : <a href="/APropos" className="link">À propos de QuelResto</a> et <a href="/Fonctionnement" className="link">Fonctionnement du site</a>.
                        </p>
                    </div>
                )}

                {listRestoBackup && listRestoBackup.length > 0 && <DefilmentBar currentPage={currentHomePage} totalResult={listRestoFilter.length > 0 ?  listRestoFilter.length : (listRestoBackup && listRestoBackup.length > 0 ? listRestoBackup.length : 0) } nbrForPage={30} setCurrentPage={setCurrentHomePage} nbrPages={Math.ceil(listRestoFilter.length / 30)} dom="bodyCorp"/> }
            </div>
    )
}
export default MainCorp



